module.exports = __webpack_public_path__ + "b8e954d5a3399f1598932759c7fa2773.pdf";